import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Option } from 'funfix-core';
import { List, Set } from 'immutable';
import tap from 'redux-tap';
import { EmceeVariant } from '../../constants/EmceeVariants';
import { isEmceeConnect } from '../../utils/package-connect-utils';
import { getUrlParams } from '../../utils/routes-utils';
import { ANALYTICS_CATEGORY_NAVIGATION } from '../Events';
import { sendEvent } from '../Send';
import AppSpecificPasswordMapper from './mappers/AppSpecificPassword';
import DeterminingInstallModeMapper from './mappers/DeterminingInstallMode';
import InstallableAppByManualUrlMapper from './mappers/InstallableAppByManualUrl';
import InstallAppMapper from './mappers/InstallApp';
import UninstallAppMapper from './mappers/UninstallApp';
import UpgradeAppMapper from './mappers/UpgradeApp';
const ANALYTICS_MAPPERS = List([AppSpecificPasswordMapper, DeterminingInstallModeMapper, InstallableAppByManualUrlMapper, InstallAppMapper, UninstallAppMapper, UpgradeAppMapper]);
function actionToAnalyticsPayloads(action) {
  return ANALYTICS_MAPPERS.map(fn => fn(action)).filter(Boolean); // Yes it's weird, but this gives us ?T => T
}
function sendTrackingEvents(payloads, action, store) {
  const state = store.getState();
  const currentScreen = Option.of(state.analytics.modalStack.last()).getOrElse(state.analytics.currentScreen);
  payloads.map(p => {
    return {
      action: p.eventType.action,
      actionSubject: p.eventType.actionSubject,
      actionSubjectId: p.actionSubjectId,
      attributes: _objectSpread(_objectSpread({}, p.attributes), {}, {
        source: getUrlParams().source,
        emceeVariant: isEmceeConnect() ? EmceeVariant.Connect : EmceeVariant.Native
      }),
      category: Option.of(p.category).getOrElse(ANALYTICS_CATEGORY_NAVIGATION),
      containerId: p.containerId,
      containerType: p.containerType,
      objectId: p.objectId,
      objectType: p.objectType,
      source: currentScreen.name,
      tags: Option.of(p.tags).getOrElse(Set()).add('emcee').toArray()
    };
  }).forEach(p => sendEvent(p));
}
const analyticsMiddleware = tap(action => actionToAnalyticsPayloads(action), sendTrackingEvents);
export default analyticsMiddleware;